import Stripe, { loadStripe } from '@stripe/stripe-js';
import { capitalize, isNil, trimEnd } from 'lodash';

import { PaymentMethod } from '@/api/subscriptions';

export const stripePromise: Promise<Stripe.Stripe | null> = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

/**
 * @param product_name product name from stripe item
 * @returns productName: Label for the product column
 * @returns quantityLabel: Label for the quantity column
 * @returns quantityItemName: Label for an individual item in a quantity selector
 */
export const invoiceLabels = ({ product_name, interval }: { product_name: string; interval?: string }) => {
    const productName = capitalize(product_name);
    const oneLowercaseProduct = trimEnd(productName.toLowerCase(), 's'); // usually doesn't have s but trimming it off just in case
    if (productName.includes('line')) {
        return {
            productName,
            productTitle: productName.replace(' line', ' telemetry'),
            quantityLabel: 'Active lines',
            quantityItemName: 'line',
        };
    } else if (productName.includes('credit')) {
        return {
            productName,
            productTitle: 'Satellite credits',
            quantityLabel: !isNil(interval)
                ? `Recurring ${oneLowercaseProduct}s`
                : `${capitalize(oneLowercaseProduct)}s`,
            quantityItemName: 'credit',
        };
    }
    return {
        productName,
        productTitle: productName,
        quantityLabel: productName,
        quantityItemName: oneLowercaseProduct,
    };
};

export const formatPaymentMethod = (paymentMethod: Stripe.PaymentMethod): PaymentMethod => {
    const method = paymentMethod[paymentMethod.type as keyof Stripe.PaymentMethod] as Partial<
        Stripe.PaymentMethod['card'] & Stripe.PaymentMethod['us_bank_account']
    >;
    return {
        ...paymentMethod,
        customer: paymentMethod.customer ?? '',
        name: method?.brand ?? method?.bank_name ?? paymentMethod.type,
        last4: method?.last4,
    };
};
